(ns quuppa.qsm.common.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  ::available-release-channels
  (fn [db _]
    (get-in db [:releases :available-release-channels])))
